import './DataTable.scss';
import React from "react";
import { observer } from "mobx-react";
import Http from "services/Http";
import { WaitScreen } from "@countysuite/ui";

export const BasePage: React.FC = observer((props) => {
  return (
    <div>
      <WaitScreen show={Http.isFetchingData}>{Http.waitMessage}</WaitScreen>
      {props.children}
    </div>
  );
});
